<template>
  <div>
    <div style="font-size: 1.25rem" class="px-4 font-weight-bold mt-4">
      {{ $vuetify.lang.t("$vuetify.ai_response.items_image_recommend") }}
    </div>
    <v-card-text>
      {{ $vuetify.lang.t("$vuetify.ai_response.set_input_field_txt") }}
    </v-card-text>
    <v-form ref="recommend_form" class="ml-4">
      <v-row>
        <v-col cols="6" md="6" xs="12">
          <v-text-field
            type="text"
            v-model="user_id"
            :label='$vuetify.lang.t("$vuetify.ai_response.user_id")'
            dense
            outlined
            :rules="[
              required($vuetify.lang.t('$vuetify.ai_response.user_id')),
            ]"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="generateUserUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field
            type="text"
            v-model="member_id"
            :label='$vuetify.lang.t("$vuetify.ai_response.member_id")'
            dense
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="generateMemberUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field
            type="text"
            v-model="item_id"
            :label="$vuetify.lang.t('$vuetify.ai_response.item_id')"
            dense
            outlined
            :rules="[
              required($vuetify.lang.t('$vuetify.ai_response.item_id')),
            ]"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="openModal=true">
            {{ $vuetify.lang.t("$vuetify.ai_response.choose_item") }}
          </v-btn>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field
            type="text"
            v-model="image_url"
            :label="$vuetify.lang.t('$vuetify.ai_response.image_url')"
            dense
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12"></v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field
            type="number"
            :rules="priceRules"
            v-model="price"
            :label="$vuetify.lang.t('$vuetify.ai_response.price')"
            dense
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-combobox
            v-model="categories"
            :items="[]"
            :label="$vuetify.lang.t('$vuetify.ai_response.categories')"
            variant="solo"
            chips
            clearable
            outlined
            multiple
            hide-dropdown
            class="no-dropdown-icon"
            :hint="$vuetify.lang.t('$vuetify.ai_response.category_chip_hint')"
            append-icon=""
            dense
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :model-value="selected"
                close
                @click="select"
                @click:close="removeCategoryChip(item)"
                small
              >
                <span>{{ item }}</span>&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="6" md="6" xs="12">
        </v-col>

        <v-btn
          class="float-right ml-2"
          color="primary"
          @click="getRecommendedItems"
          dark
        >
          {{ $vuetify.lang.t("$vuetify.ai_response.get_response") }}
        </v-btn>
        <v-card-title>
        </v-card-title>
      </v-row>
    </v-form>
    <v-dialog v-model="openModal" max-width="90%">
      <template v-if="isLoading">
        <Loader class="mr-2 mt-6" />
      </template>
      <v-card v-else class="d-flex flex-column"
              style="overflow-y: scroll; overflow-x: hidden ; min-height: 80vh; position: relative;">
        <v-container>
          <div style="font-size: 1.25rem" class="font-weight-medium mt-8">
            {{ $vuetify.lang.t("$vuetify.ai_response.choose_item") }}
          </div>
        </v-container>

        <v-container>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="searchText"
                :label="$vuetify.lang.t('$vuetify.insights.search')"
                outlined
                dense
                single-line
                hide-details
                append-icon="mdi-magnify"
                @input="debouncedFetchCatalogItems"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-for="product in catalogItems"
              :key="product.item[mapper.item_id]"
              cols="12"
              md="3"
            >
              <v-card class="product-card" @click="setItemIdImageUrl(product.item)" outlined>
                <v-img :src="product.item[mapper.image_url]" height="100px">
                  <template #placeholder>
                    <div class="d-flex align-center justify-center grey--text text-caption" style="height: 100%">
                      {{ $vuetify.lang.t("$vuetify.ai_response.image_not_available") }}
                    </div>
                  </template>
                </v-img>
                <div class="card-content">
                  <p class="ml-4">{{ product.item[mapper.title].slice(0, 50) }}</p>
                  <strong class="ml-4">¥ {{ product.item[mapper.price] }}</strong>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <!-- pagination -->
        <v-container>
          <v-row>
            <v-col class="py-0" cols="12" md="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" class="d-flex">
            <span v-if="!isLoading" class="ma-2 font-weight-bold">
              {{ $vuetify.lang.t("$vuetify.common.page_no") }} : <span class="primary--text"> {{ catalogScrollIdStack.length }} / {{ pageCount }} </span>
            </span>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" class="d-flex">
              <v-btn class="ma-2" color="primary" :disabled="boundary === 'left' || boundary === 'both' || isLoading" @click="handlePreviousPage">
                <v-icon left>mdi-chevron-left</v-icon>
                Previous
              </v-btn>

              <v-btn class="ma-2" color="primary" :disabled="boundary === 'right' || boundary === 'both' || isLoading" @click="handleNextPage">
                Next
                <v-icon right>mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" xs="6" sm="3" md="2" class="d-flex justify-end">
              <v-select
                v-model="itemsPerPage"
                :items="rows"
                hide-details="auto"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>
        <v-card-title>
          <v-card-actions class="justify-end" style="position: absolute; bottom: 0; right: 0;">
            <v-btn color="primary" text @click="openModal=false">{{ $vuetify.lang.t("$vuetify.ai_response.close") }}</v-btn>
          </v-card-actions>
        </v-card-title>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openResponseModal" max-width="90%">
      <template v-if="responseLoading" >
        <Loader  class="mr-2 mt-6" />
      </template>
      <v-card v-else class="d-flex flex-column"
              style="overflow-y: scroll; overflow-x: hidden ; min-height: 80vh; position: relative;">

        <v-container>
          <div style="font-size: 1.25rem" class="font-weight-medium mt-8">
            {{ $vuetify.lang.t("$vuetify.ai_response.selected_item") }}
          </div>
        </v-container>
        <v-container>
          <v-row>
            <v-col  cols="12" md="3">
              <v-card class="product-card" @click="copyItemToClipBoard(selectedItem)" outlined>
                <v-img :src="selectedItem[mapper.image_url]" height="100px">
                  <template #placeholder>
                    <div class="d-flex align-center justify-center grey--text text-caption" style="height: 100%">
                      {{ $vuetify.lang.t("$vuetify.ai_response.image_not_available") }}
                    </div>
                  </template>
                </v-img>
                <div class="card-content">
                  <p class="ml-4">{{ selectedItem[mapper.title] && selectedItem[mapper.title].slice(0, 50) }}</p>
                  <strong class="ml-4">¥ {{ selectedItem[mapper.price] }}</strong>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <v-container>
          <div style="font-size: 1.25rem" class="font-weight-medium mt-8">
            {{ $vuetify.lang.t("$vuetify.ai_response.items_image_recommend") }}
          </div>
        </v-container>

        <v-container>
          <v-row v-if="recommendedItems.length > 0">
            <v-col v-for="product in recommendedItems" :key="product[mapper.item_id]" cols="12" md="3">
              <v-card class="product-card" @click="copyItemToClipBoard(product)" outlined>
                <v-img :src="product[mapper.image_url]" height="100px">
                  <template #placeholder>
                    <div class="d-flex align-center justify-center grey--text text-caption" style="height: 100%">
                      {{ $vuetify.lang.t("$vuetify.ai_response.image_not_available") }}
                    </div>
                  </template>
                </v-img>
                <div class="card-content">
                  <p class="ml-4">{{ product[mapper.title].slice(0, 50) }}</p>
                  <strong class="ml-4">¥ {{ product[mapper.price] }}</strong>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-col v-else  class="d-flex align-items-center pa-0">
            <v-icon class="text-info mr-2">mdi-information</v-icon>
            <span class="text-body-1">
              {{ $vuetify.lang.t("$vuetify.ai_response.recommended_items_not_found") }}
            </span>
          </v-col>
        </v-container>
        <v-divider></v-divider>
        <v-card-title>
          <v-card-actions class="justify-end" style="position: absolute; bottom: 0; right: 0;">
            <v-btn color="primary" text @click="openResponseModal=false">{{ $vuetify.lang.t("$vuetify.ai_response.close") }}</v-btn>
          </v-card-actions>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { IMAGE_ITEMS_RECOMMEND, ADD_ALERT, GET_CATALOG_ITEMS } from "@/store/_actiontypes";
import { mapState, mapActions } from "vuex";
import Loader from "@/components/common/loader/Loader";
import _ from "lodash";
export default {
  components: {
    Loader
  },
  props: {
    mapper: {
      type: Object,
    },
    // catalogItems: {
    //   type: Array
    // }
  },
  data() {
    return {
      user_id: "",
      member_id: "",
      item_id: "",
      image_url: "",
      price: 22,
      categories: [],
      openModal: false,
      openResponseModal: false,
      recommendedItems : [],
      responseLoading: false,
      priceRules: [
        value => value >= 1 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 1`,
      ],
      selectedItem: {},
      itemsPerPage: 10,
      rows: [5, 10, 20],
      catalogScrollIdStack: [],
      searchText: "",
      boundary: "",
      isLoading: false,
      pageCount: 1,
      catalogItems: []
    };
  },
  mounted(){
    this.getCatalogItems()
  },
  created(){
    this.debouncedFetchCatalogItems = _.debounce(() => {
      this.catalogScrollIdStack.pop()
      this.catalogScrollIdStack.pop()
      this.getCatalogItems()
    }, 500);
  },
  watch: {
    itemsPerPage: {
      handler() {
        this.catalogScrollIdStack = []
        this.getCatalogItems();
      },
      immediate: false,
    },
  },
  computed: {
    ...mapState({
      selectedProject: (state) => state.project.selectedProject,
      user: (state) => state.account.user
    }),
  },
  methods: {
    ...mapActions("ai_response", [IMAGE_ITEMS_RECOMMEND]),
    ...mapActions("project", [GET_CATALOG_ITEMS ]),
    ...mapActions("alert", [ADD_ALERT]),
    required(fieldName) {
      return (value) => !!value || `${fieldName} ${this.$vuetify.lang.t("$vuetify.ai_response.is_required")}`;
    },
    generateMemberUUID() {
      this.member_id = uuidv4()
    },
    generateUserUUID() {
      this.user_id = uuidv4()
    },
    copyItemToClipBoard(item){
      navigator.clipboard.writeText(JSON.stringify(item, null, 2));
      this.$store.dispatch(
        `alert/${ADD_ALERT}`, {
          message: this.$vuetify.lang.t("$vuetify.ai_response.item_copied_message"),
          color: "success",
        }, { root: true }
      );
    },
    setItemIdImageUrl(item){
      navigator.clipboard.writeText(JSON.stringify(item, null, 2));
      this.$store.dispatch(
        `alert/${ADD_ALERT}`, {
          message: this.$vuetify.lang.t("$vuetify.ai_response.item_copied_message"),
          color: "success",
        }, { root: true }
      );
      this.item_id = item[this.mapper.item_id]
      this.image_url = item[this.mapper.image_url]
      this.selectedItem = item
      this.openModal = false
    },
    removeCategoryChip(item){
      this.categories = this.categories.filter(category => category != item)
    },
    getFormData(){
      return {
        member_id : this.member_id,
        user_id: this.user_id,
        item_id: this.item_id,

      }
    },
    validateForm() {
      return this.$refs.recommend_form.validate();
    },
    handleNextPage() {
      this.getCatalogItems();
    },
    handlePreviousPage() {
      this.catalogScrollIdStack.pop()
      this.catalogScrollIdStack.pop()
      this.getCatalogItems();
    },
    getCatalogItems(){
      const payload = {
        text: this.searchText || null,
        size: this.itemsPerPage
      }
      const catalogScrollIdStackLength = this.catalogScrollIdStack.length
      if (catalogScrollIdStackLength !== 0) {
        payload["scroll_id"] = this.catalogScrollIdStack [catalogScrollIdStackLength - 1]
      }
      this.isLoading = true
      let count = 1
      this.GET_CATALOG_ITEMS({
        project_id: this.selectedProject.id,
        payload
      }).then(
        (response) => {
          if (response?.data?.detail?.response?.total_hits) {
            count = Math.ceil(
              response?.data?.detail?.response?.total_hits / this.itemsPerPage
            );
            this.pageCount = count
          }

          this.catalogItems = response.data.detail.response?.items
          if (response?.data?.detail?.response?.next_scroll_id){
            this.catalogScrollIdStack = [...this.catalogScrollIdStack, response?.data?.detail?.response?.next_scroll_id]
          }
          this.boundary =
            count === 1 ? "both" :
              this.catalogScrollIdStack.length === 1 ? "left" :
                count === this.catalogScrollIdStack.length ? "right" : "";
        },
        (error) => {
          console.error("error", error)
        }
      ).finally(()=> {
        this.isLoading = false
      })
    },
    getRecommendedItems(){
      const valid = this.validateForm()
      if(!valid) return
      this.openResponseModal = true
      this.responseLoading = true
      const item_details = {};

      if (this?.image_url) {
        item_details.image_url = this.image_url;
      }

      if (this?.price) {
        item_details.price = Number(this.price);
      }

      if (this?.categories) {
        item_details.category = this.categories;
      }
      this.IMAGE_ITEMS_RECOMMEND({
        project_id: this.selectedProject.id,
        user_id: this.user_id,
        member_id: this.member_id,
        item_id: this.item_id,
        item_details
      }).then(
        (response) => {
          this.responseLoading = false
          this.recommendedItems = response.data.detail.response
        },
        (error) => {
          this.openResponseModal = false
          if(error.status === 422){
            this.$store.dispatch(
              `alert/${ADD_ALERT}`, {
                message: JSON.stringify(error?.response?.data?.detail),
                color: "error",
              }, { root: true }
            );
          } else {
            this.$store.dispatch(
              `alert/${ADD_ALERT}`, {
                message: error?.response?.data?.detail?.response,
                color: "error",
              }, { root: true }
            );
          }
          console.error("error", error)
        }
      );
    }
  }
};
</script>

<style scoped>
.product-card {
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}
.card-content {
  padding: 4px;
}

.card-content .v-card-title {
  margin-bottom: 0;
  font-size: 16px;
}

.card-content .v-card-subtitle {
  margin-bottom: 8px;
}
</style>
